<h2 mat-dialog-title>
  <ng-container *ngIf="!isTrial; else trialTitle">
    {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.TITLE' | translate }}
  </ng-container>
  <ng-template #trialTitle>
    {{ 'CHANGE_EDITION_DIALOG.UPGRADE_FROM_TRIAL' | translate }}
  </ng-template>
</h2>
<mat-dialog-content>
  <div class="select-product-edition">
    <div class="select-product-edition-text">
      {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.SELECT_EDITION' | translate }}
    </div>

    <div class="app-info-edition-dropdown">
      <div class="app-icon">
        <va-icon
          *ngIf="data.appIconUrl"
          [diameter]="32"
          [iconName]="data.appIconUrl"
          [iconUrl]="data.appIconUrl + '=s256'"
        ></va-icon>
      </div>
      <div class="app-name">
        {{ data.appName }}
      </div>
      <mat-select
        class="edition-dropdown"
        *ngIf="editions$ | async as editions; else loading"
        [formControl]="selectedEditionIdControl"
        [(ngModel)]="selectedEditionId"
        #select="matSelect"
      >
        <mat-option *ngFor="let edition of editions" [value]="edition.editionId">
          <div class="edition-option">
            <div>
              {{ edition.editionTitle }}
            </div>
            <div class="badge" *ngIf="edition.editionId === currentEditionId && select.panelOpen">
              {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CURRENT' | translate }}
            </div>
          </div>
        </mat-option>
      </mat-select>

      <ng-template #loading>
        <mat-spinner [diameter]="32" [strokeWidth]="4"></mat-spinner>
      </ng-template>
    </div>
  </div>

  <div *ngIf="(satisfiesDependency$ | async) === false" class="dependent-product-cancellation-warning">
    <glxy-alert type="warning">
      <strong>{{ formattedDependentProductsNames }}</strong>
      {{ 'CHANGE_EDITION_DIALOG.DEPENDENT_PRODUCTS_CANCELLATION_WARNING' | translate }}
      <strong>{{ formattedDependentProductsNames }}.</strong>
    </glxy-alert>
  </div>

  <div class="confirmation">
    <app-wsp-multisite-consent-box
      [selectedEditionId]="selectedEditionId"
      [wspMultisiteEditionDemo]="wspMultisiteEditionDemo"
      [wspMultisiteEditionProd]="wspMultisiteEditionProd"
      [currentEditionId]="currentEditionId"
    ></app-wsp-multisite-consent-box>
    <div class="checkbox-container">
      <mat-checkbox class="checkbox" color="primary" [(ngModel)]="confirmationCheckbox"></mat-checkbox>
      <ng-container *ngIf="!isTrial; else trialCheckbox">
        <span class="checkbox-text">
          {{
            selectedEditionId === wspMultisiteEditionDemo || selectedEditionId === wspMultisiteEditionProd
              ? ('MULTISITE_CONSENT_BOX.MULTISITE_CONFIRMATION' | translate)
              : ('CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CONFIRMATION' | translate)
          }}
        </span>
      </ng-container>
    </div>
    <ng-template #trialCheckbox>
      <span>
        {{ 'CHANGE_EDITION_DIALOG.TRIAL_CONFIRMATION' | translate }}
      </span>
    </ng-template>
  </div>
  <div class="change-edition-message" *ngIf="notInstantBillable">
    <ng-container *ngIf="!isTrial; else trialBilling">
      {{ 'CHANGE_EDITION_DIALOG.BEFORE_CHANGE' | translate }}
    </ng-container>
    <ng-template #trialBilling>
      {{ 'CHANGE_EDITION_DIALOG.BEFORE_UPGRADE' | translate }}
    </ng-template>
    <a [routerLink]="['/billing/by-purchase']" [queryParams]="{ 'show-edit-payment-info': 'true' }">
      {{ 'COMMON.ACTION_LABELS.ADD' | translate }}
    </a>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button matDialogClose color="primary">
    {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CANCEL_BUTTON' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="activateEditionForApp()"
    [disabled]="
      (!isTrial && selectedEditionId === currentEditionId) ||
      !confirmationCheckbox ||
      submitting ||
      notInstantBillable ||
      currentEditionId === wspMultisiteEditionDemo ||
      currentEditionId === wspMultisiteEditionProd
    "
  >
    <ng-container *ngIf="!submitting; else submit">
      <ng-container *ngIf="!isTrial; else trialButton">
        {{ 'CHANGE_EDITION_DIALOG.ACTIVE_CAMPAIGN.CHANGE_EDITION_BUTTON' | translate }}
      </ng-container>
      <ng-template #trialButton>
        {{ 'CHANGE_EDITION_DIALOG.UPGRADE_TO_PAID_BUTTON' | translate }}
      </ng-template>
    </ng-container>
    <ng-template #submit>
      <mat-spinner [diameter]="24" [strokeWidth]="4"></mat-spinner>
    </ng-template>
  </button>
</mat-dialog-actions>
